import PropTypes from 'prop-types';
import { ABUtils, Config } from '../../utils';

export const SiteSelector = ({ render }) => {
    const websiteId = Config.get('website');
    const language = Config.get('lang').substring(0, 2);
    const selected = Config.get('isMultipleLocales') ? `${websiteId}_${language}` : websiteId;
    const { isCatalanEnabled } = ABUtils.getABs();

    let websiteList = JSON.parse(Config.get('countrySelectorConfig'))
        .continentItems.map((i) => i.countryDTOs, []).flat()
        .sort((a, b)=> a.id < b.id ? -1 : 1)
        .map((a) => a.countryDTOs ? a.countryDTOs.map((b) => { return { ...a, ...b }; }, []) : a).flat() || [];

    if (!isCatalanEnabled) {
        websiteList = websiteList.filter((item) => item.id !== 'ES_ca' && item.id !== 'OPES_ca');
    }

    const arIndex = websiteList.findIndex((item) => item.id === 'AR');

    if (arIndex >= 0) {
        websiteList[arIndex].currency = 'US$';
    }

    const handleChange = (event) =>{
        const url = websiteList.find((item) => item.id === event.target.value).link;
        const { protocol } = window.location;
        window.location.href = `${protocol}${url}`;
    };

    return (
        render({ selected, websiteList, language, handleChange })
    );
};

SiteSelector.propTypes = {
    render: PropTypes.func.isRequired,
};
